import React, { Component } from "react";

import AceEditor from "react-ace";

import "brace/mode/javascript";
import "brace/theme/github";

import Measure from 'react-measure'

export default class CodeEditor extends Component {
  state = {
    dimensions: {
      width: -1,
      height: -1
    }
  }

  

  render() {
    const w = this.props.width || 350;//this.state.dimensions.width;
    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          this.setState({ dimensions: contentRect.bounds })
        }}
      >
        {({ measureRef }) =>
          <div ref={measureRef}>
            <AceEditor
              mode="javascript"
              theme="github"
              name={"editor" + this.props.id}
              width={w.toString()+"px"}
              height={this.props.height}
              onLoad={this.props.onLoad}
              onChange={this.props.onChange}
              fontSize={12}
              showPrintMargin={false}
              showGutter={true}
              highlightActiveLine={!this.props.readOnly}
              readOnly={this.props.readOnly}
              value={this.props.value}
              cursorStart={0}
              setOptions={{
                enableLiveAutocompletion: true,
                showLineNumbers: true,
                highlightGutterLine: !this.props.readOnly,
                tabSize: 2
              }}
            />
          </div>
        }
      </Measure>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/CodeEditor.js